// import { 'achieve', 'website-wfs', 'website-fdr', 'website-ffn' } from 'utils/environmentConfig'

/**
 * Feature toggles. Some should remain permanent, but consider removing flags after page/feature is
 * launched when appropriate.
 */
export const ACX_WEB_CLEAR_CACHE = 'acx-apollo-memory-cache-clear'
export const ACX_DEBUG_LOGS = 'acx-debug-logs'
export const ACX_WEB_ENABLE_ACCELERATION_LOAN = 'acx-web-enable-acceleration-loan'
export const ACX_WEB_ENABLE_ALCHEMER_SURVEY = 'acx-web-enable-alchemer-survey'
export const ACX_WEB_ENABLE_ARTICLE_HOOK = 'acx-web-enable-article-hook'
export const ACX_WEB_ENABLE_AUTHORS = 'acx-web-enable-authors'
export const ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS = 'acx-website-cache-purge-slack-alerts'
export const ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR = 'acx-web-enable-debt-assessment-tool'
export const ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR_MXP = 'acx-web-enable-debt-assessment-tool-mxp'
export const ACX_WEB_ENABLE_DIRECT_MAIL_LINK = 'acx-web-enable-direct-mail-link'
export const ACX_WEB_ENABLE_FAQ_HOME_EQUITY_LOAN = 'acx-web-enable-faq-home-equity-loan'
export const ACX_WEB_ENABLE_FAQ_PERSONAL_LOAN = 'acx-web-enable-faq-personal-loan'
export const ACX_WEB_ENABLE_FAQ_DEBT_RELIEF = 'acx-web-enable-faq-debt-relief'
export const ACX_WEB_ENABLE_GLOSSARY = 'acx-web-enable-glossary'
export const ACX_WEB_ENABLE_STATE_PAGES = 'axc-state-pages'
export const ACX_WEB_ENABLE_MXP_DEBT_CHECKUP = 'acx-web-enable-mxp-debt-checkup'
export const ACX_WEB_ENABLE_MEGA_MENU = 'acx-web-enable-mega-menu'
export const ACX_WEB_ENABLE_NAV_TITLES = 'acx-web-enable-nav-titles'
export const ACX_WEB_ENABLE_SIGN_IN_MXP = 'acx-web-enable-sign-in-mxp'
export const ACX_WEB_ENABLE_SITE_WIDE_BANNER = 'acx-web-enable-site-wide-banner'
export const ACX_HELOC_TOOL = 'acx-web-enable-heloc-tool'
export const ACX_CHATBOT = 'acx-chatbot-2'
export const FDR_CHATBOT = 'ai-chat-test-2'
export const ACX_WEB_ENABLE_PRO = 'acx-web-enable-pro'
export const ACX_WEB_ENABLE_EH_CONSENT_TEALIUM = 'acx-web-enable-eh-consent-tealium'

/**
 * Feature experiment toggles object map. Enabled for all including crawlers.
 */
const FEATURES = {
  ['achieve']: {
    ACX_WEB_ENABLE_ALCHEMER_SURVEY,
    ACX_WEB_ENABLE_NAV_TITLES,
    ACX_WEB_ENABLE_FAQ_DEBT_RELIEF,
    ACX_WEB_ENABLE_FAQ_PERSONAL_LOAN,
    ACX_WEB_ENABLE_FAQ_HOME_EQUITY_LOAN,
    ACX_WEB_ENABLE_SITE_WIDE_BANNER,
    ACX_WEB_ENABLE_ARTICLE_HOOK,
    ACX_WEB_ENABLE_ACCELERATION_LOAN,
    ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR,
    ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR_MXP,
    ACX_WEB_ENABLE_SIGN_IN_MXP,
    ACX_WEB_ENABLE_AUTHORS,
    ACX_WEB_ENABLE_MXP_DEBT_CHECKUP,
    ACX_WEB_ENABLE_DIRECT_MAIL_LINK,
    ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS,
    ACX_WEB_CLEAR_CACHE,
    ACX_WEB_ENABLE_GLOSSARY,
    ACX_WEB_ENABLE_STATE_PAGES,
    ACX_HELOC_TOOL,
    ACX_DEBUG_LOGS,
    ACX_WEB_ENABLE_PRO,
    ACX_WEB_ENABLE_EH_CONSENT_TEALIUM,
  },
  ['website-wfs']: { ACX_WEB_CLEAR_CACHE, ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS, ACX_DEBUG_LOGS },
  ['website-fdr']: {
    ACX_WEB_ENABLE_GLOSSARY,
    ACX_WEB_CLEAR_CACHE,
    ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS,
    ACX_DEBUG_LOGS,
  },
  ['website-ffn']: { ACX_WEB_CLEAR_CACHE, ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS, ACX_DEBUG_LOGS },
  ['website-bills']: {
    ACX_WEB_CLEAR_CACHE,
    ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS,
    ACX_DEBUG_LOGS,
  },
}

/**
 * Experiment toggles. These should removed once experiments are concluded.
 */
const ACX_DTI_CONTENT_EXPERIMENT = 'acx-dti-content-experiment'
const ACX_WEB_BANNER_POSITION = 'acx-web-banner-position'
const ACX_WEB_EXPERIMENT_AHL_HEADLINE_RATE = 'acx-ahl-headline-rate'
const ACX_WEB_EXPERIMENT_GOOD_MOLO_SKELETON = 'acx-good-molo-skeleton-experiment'
const ACX_WEB_EXPERIMENT_HL_HUB_TEMPLATE = 'acx-hl-hub-template-experiment'
const ACX_WEB_EXPERIMENT_HOME_HERO_V2 = 'acx-experiment-home-hero-v2'
const ACX_WEB_EXPERIMENT_HOME_PAGE_PZN = 'acx-home-page-pzn'
const ACX_WEB_EXPERIMENT_HOMEPAGE_TRUST_PILOT_TRUSTMARKER =
  'acx-homepage-trust-pilot-trustmarker-experiment'
const HOME_EQUITY_LOAN_MP_EXPERIMENT = 'home-equity-loan-mp-experiment'
const ACX_MARKETING_EXPERIMENT = 'acx-marketing-version'
const ACX_HELOC_HERO = 'acx-heloc-hero-2'
const ACX_HOME_EQUITY_LOAN_HERO_2 = 'acx-home-equity-loan-hero-2'
const ACX_DEBT_CONSOLIDATION_HERO = 'acx-debt-consolidation-hero-2'
const ACX_DEBT_RELIEF_HERO = 'acx-debt-relief-hero'
const ACX_DEBT_PAYOFF_CALCULATOR_V3 = 'acx-debt-payoff-calculator-v-3'
const ACX_PERSONAL_LOANS_HERO_2 = 'acx-personal-loans-hero-2'

/**
 * Feature experiment toggles object map. These flags will not be included if crawlers are detected.
 */
const EXPERIMENTS = {
  ['achieve']: {
    ACX_PERSONAL_LOANS_HERO_2,
    ACX_HOME_EQUITY_LOAN_HERO_2,
    ACX_DEBT_RELIEF_HERO,
    ACX_HELOC_HERO,
    ACX_DTI_CONTENT_EXPERIMENT,
    ACX_WEB_BANNER_POSITION,
    ACX_WEB_EXPERIMENT_AHL_HEADLINE_RATE,
    ACX_WEB_EXPERIMENT_GOOD_MOLO_SKELETON,
    ACX_WEB_EXPERIMENT_HL_HUB_TEMPLATE,
    ACX_WEB_EXPERIMENT_HOME_HERO_V2,
    ACX_WEB_EXPERIMENT_HOME_PAGE_PZN,
    ACX_WEB_EXPERIMENT_HOMEPAGE_TRUST_PILOT_TRUSTMARKER,
    HOME_EQUITY_LOAN_MP_EXPERIMENT,
    ACX_HELOC_TOOL,
    ACX_MARKETING_EXPERIMENT,
    ACX_DEBT_PAYOFF_CALCULATOR_V3,
    ACX_DEBT_CONSOLIDATION_HERO,
  },
  ['website-wfs']: {},
  ['website-fdr']: {
    ACX_WEB_ENABLE_MEGA_MENU,
  },
  ['website-ffn']: {},
  ['website-bills']: {},
}

/**
 * All possible feature toggles whether basic feature enablement or experiments. This object is
 * referenced in components to determine if a feature should be enabled or not.
 */
export const FEATURE_TOGGLES = {
  EXPERIMENTS,
  FEATURES,
  ['achieve']: {
    ...FEATURES['achieve'],
    ...EXPERIMENTS['achieve'],
  },
  ['website-wfs']: {
    ...FEATURES['website-wfs'],
    ...EXPERIMENTS['website-wfs'],
  },
  ['website-fdr']: {
    ...FEATURES['website-fdr'],
    ...EXPERIMENTS['website-fdr'],
  },
  ['website-ffn']: {
    ...FEATURES['website-ffn'],
    ...EXPERIMENTS['website-ffn'],
  },
  ['website-bills']: {
    ...FEATURES['website-bills'],
    ...EXPERIMENTS['website-bills'],
  },
}

export const CLIENT_SIDE_FEATURE_TOGGLES = {
  achieve: [ACX_CHATBOT],
  'website-wfs': [],
  'website-fdr': [FDR_CHATBOT],
  'website-ffn': [],
  'website-bills': [],
}

export const SESSION_BASED_FEATURE_TOGGLES = []

export const EVENT_TYPES = {
  START: 'start',
  CONVERSION: 'conversion',
  TRACK: 'track',
}

// values should be all lower case
export const VARIATIONS = {
  CONTROL: 'control',
  VARIATION_A: 'variation_a',
  VARIATION_B: 'variation_b',
  VARIATION_C: 'variation_c',
  UNASSIGNED: 'unassigned',
  OFF: 'off',
}

export const VARIATIONS_UPPER = {
  CONTROL: 'Control',
  VARIATION_A: 'Variation_A',
  VARIATION_B: 'Variation_B',
  VARIATION_C: 'Variation_C',
  UNASSIGNED: 'Unassigned',
  OFF: 'Off',
}

// AHL Direct Mail PZN V1 routes
export const AHL_PZN_ROUTES_IGNORE = ['/debt-relief', '/privacy']

export const STANDALONE_ROUTE_EXPERIMENT_BLACKLIST = [ACX_WEB_BANNER_POSITION]

export default FEATURE_TOGGLES
